import { RhinoImage, RhinoImageRatio } from '../../data/image';
import { RhinoProgram } from '../../data/program/type';
import { KalturaProgramAssetLean } from '../composed';
import { KalturaMediaImage } from '../objects';
import { fromKalturaBoolean } from '../utils';

export function processPhoenixPrograms(data: KalturaProgramAssetLean[], channelId: number): RhinoProgram[] {
  return data.map((program) => ({
    id: program.id,
    channelId,
    externalId: program.externalId,
    name: program.name,
    title: program.name,
    description: program.description,
    type: 'program',
    ...(program.metas.EpisodeName && { episodeName: String(program.metas.EpisodeName.value) }),
    ...(program.metas.EpisodeNumber && { episodeNumber: Number(program.metas.EpisodeNumber.value) }),
    ...(program.metas.Year && { year: String(program.metas.Year.value) }),
    ...(program.metas.SeasonNumber && { seasonNumber: Number(program.metas.SeasonNumber.value) }),
    ...(program.tags.SeriesName && { seriesName: program.tags.SeriesName.objects[0].value }),
    ...(program.metas.SeriesID && { seriesId: String(program.metas.SeriesID.value) }),
    startDate: program.startDate * 1000,
    endDate: program.endDate * 1000,
    images: processPhoenixImages(program.images),
    ...(program.tags.ParentalRating && { parentalRating: Number(program.tags.ParentalRating.objects[0].value) }),
    ...(program.enableCatchUp && { enableCatchUp: true }),
    ...(program.enableCdvr && { enableCdvr: true }),
    ...(program.enableStartOver && { enableStartOver: true }),
    ...(program.enableTrickPlay && { enableTrickPlay: true }),
    hasMosaic: fromKalturaBoolean(program.metas.IsMosaicEvent),
    isAdult: fromKalturaBoolean(program.metas.Adult),
    isSeries: fromKalturaBoolean(program.metas.IsSeries),
    isPopular: fromKalturaBoolean(program.metas.IsPopular),
    ...(program.tags.MosaicInfo && { mosaicExternalId: program.tags.MosaicInfo.objects[0]?.value.split('=')[1] }),
  }));
}

export function processPhoenixImages(images: KalturaMediaImage[]): RhinoImage[] {
  return images.map((image) => ({
    ratio: image.ratio as RhinoImageRatio, // TODO Validate `image.ratio` fits `RhinoImageRatio` type
    type: image.imageTypeId,
    url: image.url,
  }));
}
